import { inject, Pipe, PipeTransform } from '@angular/core';
import { of } from 'rxjs';
import { BazisEntityService } from '@bazis/shared/services/entity.service';
import { map } from 'rxjs/operators';

/**
 * TransitPipe loads a transit entity by id and returns its `$snapshot`.
 *
 * It calls `BazisEntityService.getEntity$('statusy.transit', encodeURIComponent(id))`.
 * Use with the `async` pipe. If `id` is falsy, it returns `of(null)`.
 *
 * Template usage:
 *```html
 *    @let transit = (id | transit | async);
 *    @if (transit) {
 *       <span>{{ transit?.name }}</span>
 *    }
 *```
 */
@Pipe({
    name: 'transit',
    standalone: true,
})
export class TransitPipe implements PipeTransform {
    protected entityService = inject(BazisEntityService);

    /**
     * Load transit by id and return its `$snapshot`.
     *
     * @param id Transit id string.
     * @returns Observable of `$snapshot` or `of(null)` when id is empty.
     */
    transform(id: string) {
        if (!id) return of(null);

        return this.entityService
            .getEntity$('statusy.transit', encodeURIComponent(id))
            .pipe(map((v) => v?.$snapshot));
    }
}
